import { createSlice } from '@reduxjs/toolkit';

export const VH_SIDEBAR_TABS = {
  VITALS: {
    id: 1,
    displayName: 'Vitals',
    shouldShow: ({ SSVH }) => SSVH.Type === 'medical',
  },
  CHAT: {
    id: 2,
    displayName: 'Chat',
    shouldShow: ({ SSVH }) => true,
  },
  ACTIONS: {
    id: 3,
    displayName: 'Actions',
    shouldShow: ({ SSVH, actions }) =>
      SSVH.Type !== 'branching' && actions.length > 0,
  },
  RESULTS: {
    id: 4,
    displayName: 'Results',
    shouldShow: ({ SSVH }) => SSVH.Type !== 'branching',
  },
};

const VHPlayerSlice = createSlice({
  name: 'vhPlayer',
  initialState: {
    sidebarVisible: false,
    // sidebarTypeVisible: false, // false or id from VH_SIDEBAR_TABS
    overlays: {
      objectives: {
        key: 'objectives',
        title: 'Objectives',
        visible: true,
      },
    },
    moreInfoVisible: false,
    isFullscreen: false,
    isEmbedded: false, // for when accessed as standalone e.g. share link or scorm embed
    isPublicUserSession: false, // for if the user is accessing an (embedded) session as a public user
    isForceDisabled: false, // used for e.g. heygen player when heygen has disconnected
    userSelectedLocale: null,
  },
  reducers: {
    setSidebarVisible: (state, action) => {
      state.sidebarVisible = action.payload;
    },
    // setSidebarTypeVisible: (state, action) => {
    //   state.sidebarTypeVisible = action.payload;
    // },
    toggleOverlay: (state, action) => {
      state.overlays[action.payload].visible =
        !state.overlays[action.payload].visible;
    },
    setMoreInfoVisible: (state, action) => {
      state.moreInfoVisible = action.payload;
    },
    setFullscreen: (state, action) => {
      state.isFullscreen = action.payload;
    },
    setIsEmbedded: (state, action) => {
      state.isEmbedded = action.payload;
    },
    setIsPublicUserSession: (state, action) => {
      state.isPublicUserSession = action.payload;
    },
    setIsForceDisabled: (state, action) => {
      state.isForceDisabled = action.payload;
    },
    setUserSelectedLocale: (state, action) => {
      state.userSelectedLocale = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  // setSidebarTypeVisible,
  toggleOverlay,
  setMoreInfoVisible,
  setFullscreen,
  setIsEmbedded,
  setSidebarVisible,
  setIsForceDisabled,
  setIsPublicUserSession,
  setUserSelectedLocale,
} = VHPlayerSlice.actions;

// export const sidebarTypeVisibleSelector = (state) =>
//   Object.values(VH_SIDEBAR_TABS).find(
//     (tab) => tab.id === state.vhPlayer.sidebarTypeVisible
//   );
export const sidebarVisibleSelector = (state) => state.vhPlayer.sidebarVisible;
export const isForceDisabledSelector = (state) =>
  state.vhPlayer.isForceDisabled;
export const moreInfoVisibleSelector = (state) =>
  state.vhPlayer.moreInfoVisible;
export const overlaysSelector = (state) => state.vhPlayer.overlays;
export const isFullscreenSelector = (state) => state.vhPlayer.isFullscreen;
export const isEmbeddedPlayerSelector = (state) => state.vhPlayer.isEmbedded;
export const userSelectedLocaleSelector = (state) =>
  state.vhPlayer.userSelectedLocale;
export const isPublicUserSessionSelector = (state) =>
  state.vhPlayer.isPublicUserSession;

export default VHPlayerSlice;
